import axios from "axios"
import { store } from 'react-notifications-component';
import messages from './messages'
import { ROOT_URL, notification, GET_STATISTICS, GET_STATISTICS_COUNT, LOADING } from "../constants"

export const getStatistics = (data, intl) => {

    return (dispatch) => {
        dispatch({type: LOADING, payload: true})
        axios.get(`${ROOT_URL}/statistics?${data}`)
		.then((response) => {
            if (response.status === 200) {
                dispatch({type: GET_STATISTICS, payload: response.data})
                dispatch({type: LOADING, payload: false})
            }
        })
        .catch(({response}) => {
            console.log("error", response)
            store.addNotification({
                title: intl.formatMessage(messages.errorTitle),
                message: intl.formatMessage(messages.commonError),
                type: 'warning',
                ...notification
            })
            dispatch({type: LOADING, payload: false})
        })
    }
}


export const getStatisticsCount = (data="", intl) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true})
        axios.get(`${ROOT_URL}/statistics/count?${data}`)
		.then((response) => {
            if (response.status === 200) {
                dispatch({type: GET_STATISTICS_COUNT, payload: response.data})
                dispatch({type: LOADING, payload: false})
            }
        })
        .catch(({response}) => {
            console.log("error", response)
            store.addNotification({
                title: intl.formatMessage(messages.errorTitle),
                message: intl.formatMessage(messages.commonError),
                type: 'warning',
                ...notification
            })
            dispatch({type: LOADING, payload: false})
        })
    }
}